import {intlShape, utils} from '@wallaby-ui/core';
import classNames from 'classnames';
import {pick} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import {Form} from 'react-bootstrap';
import {defineMessages, injectIntl} from 'react-intl';

import styles from './TextBox.less';
import stylesAutoLayout from '../AutoLayout.less';
import AutoLayoutService from 'src/js/lib/auto_layout/auto_layout_service';
import {ContentProperty} from 'src/js/model/auto_layout_content_schema';
import {LayoutProperty} from 'src/js/model/auto_layout_layout_schema';
import {MetadataSchema} from 'src/js/model/auto_layout_metadata_schema';
import {KEYWORD_PROP_CONTENT_VALUE} from 'src/js/model/auto_layout_screen_data_helpers';

export const I18N = defineMessages({
  EMPTY_DATA: {
    id: 'autoLayout.emptyData',
    defaultMessage: '-----',
    description: 'value displayed if data is empty',
  },
});

class TextBox extends React.PureComponent {
  constructor() {
    super();

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    const {onDataChange} = this.props;
    onDataChange(this.getOnDataChangeData(e.target.value));
  }

  getOnDataChangeData(newData) {
    const {label} = this.props;
    return {
      ...pick(this.props, ['pathToData', 'data']),
      label,
      newData: {[KEYWORD_PROP_CONTENT_VALUE]: newData},
    };
  }

  getTextOnlyValue() {
    const {data, intl} = this.props;
    return data &&
      data[KEYWORD_PROP_CONTENT_VALUE] &&
      data[KEYWORD_PROP_CONTENT_VALUE] !== ''
      ? data[KEYWORD_PROP_CONTENT_VALUE]
      : utils.TranslateUtils.translate(I18N.EMPTY_DATA, intl);
  }

  render() {
    const {
      data,
      hasError,
      idSuffix,
      inputName,
      isReadOnly,
      isTextOnly,
      screenId,
    } = this.props;
    const textOnlyValue = this.getTextOnlyValue();
    return isTextOnly ? (
      <span
        className={stylesAutoLayout.dlScreenComponentInput}
        title={textOnlyValue}
      >
        {textOnlyValue}
      </span>
    ) : (
      <Form.Control
        as='input'
        type='text'
        size='sm'
        name={inputName}
        id={AutoLayoutService.getComponentId(screenId, inputName, idSuffix)}
        className={classNames(
          styles.dlTextBoxInput,
          stylesAutoLayout.dlScreenComponentInput,
          {[styles.dlValidationError]: hasError}
        )}
        value={data[KEYWORD_PROP_CONTENT_VALUE] || ''}
        disabled={isReadOnly}
        onChange={this.handleChange}
      />
    );
  }
}

TextBox.displayName = 'TextBox';

/* eslint-disable react/no-unused-prop-types */
TextBox.propTypes = {
  content: PropTypes.instanceOf(ContentProperty).isRequired,
  layout: PropTypes.instanceOf(LayoutProperty).isRequired,
  metadata: PropTypes.instanceOf(MetadataSchema).isRequired,
  screenId: PropTypes.string.isRequired,
  idSuffix: PropTypes.string,
  intl: intlShape.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
  pathToData: PropTypes.string,
  isReadOnly: PropTypes.bool,
  isTextOnly: PropTypes.bool,
  inputName: PropTypes.string,
  label: PropTypes.string,
  expanded: PropTypes.bool,
  onDataChange: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
};

TextBox.defaultProps = {
  data: {},
  idSuffix: '',
  pathToData: '',
  isReadOnly: false,
  isTextOnly: false,
  inputName: '',
  label: '',
  expanded: false,
  hasError: false,
};

export default injectIntl(TextBox);
